import React, { useMemo, useRef, useState } from "react";
import { Modal } from "antd";
import SwipeLeftIconSvg from "../../assets/ReactSvg/SwipeLeftIconSvg";
import SwipeRightIconSvg from "../../assets/ReactSvg/SwipeRightIconSvg";
import TinderCard from "react-tinder-card";
import SoupThumbnail from "../../assets/soup_thumbnail.png";
import { useDispatch, useSelector } from "react-redux";
import {
  addTempUser,
  getDishRecommendation,
  updateFoodChoiceInfo,
} from "../../store/loginActions";
import classNames from "classnames";
import CuiratoLogoTransparent from "../../assets/CuiratoLogoTransparent.png";
import ExploreStoryLanding from "../../assets/ExploreStoryLanding.png";
import ExploreStoryLanding1 from "../../assets/ExploreStoryLanding1.png";
import ExploreStoryLanding2 from "../../assets/ExploreStoryLanding2.png";
import ExploreStoryLanding3 from "../../assets/ExploreStoryLanding3.png";
import ExploreStoryLanding4 from "../../assets/ExploreStoryLanding4.png";
import LandingStory01Img from "../../assets/LandingStory01.png";
import LandingStory02Img from "../../assets/LandingStory02.png";
import LandingStory03Img from "../../assets/LandingStory03.png";
import LandingStory04Img from "../../assets/LandingStory04.png";
import ExploreChef20 from "../../assets/ExploreChef20.png";
import ExploreChef21 from "../../assets/ExploreChef21.png";
import ExploreChef22 from "../../assets/ExploreChef22.png";
import ExploreChef23 from "../../assets/ExploreChef23.png";
import ExploreChef24 from "../../assets/ExploreChef24.png";
import ExploreChef25 from "../../assets/ExploreChef25.png";
import ExploreChef26 from "../../assets/ExploreChef26.png";
import ExploreChef27 from "../../assets/ExploreChef27.png";
import Bookmark from "../../assets/Bookmark.png";
import Share from "../../assets/Share.png";
import { useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectFade } from "swiper/modules";
import { Mousewheel, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import {
  LandingStory11,
  LandingStory12,
  LandingStory13,
  LandingStory14,
} from "./LandingPage";
import ExploreSkeleton from "./ExploreSkeleton";
import SurveyAnswer from "./SurveyAnswer/Index";
import { LandingStory01, LandingStory02, LandingStory03, LandingStory04 } from "./LandingPage1";
import {
  LandingStory21,
  LandingStory22,
  LandingStory23,
  LandingStory24,
  LandingStory25,
} from "./LandingPage2";
import LocationChoiceModal from "../VegChoiceModal/LocationChoiceModal";
import mixpanel from "mixpanel-browser";
import { uniqBy } from "lodash";
import { loginActions } from "../../store/loginSlice";
import {
  FREE_DILIVERY_DISTANCE_RANGE,
  MINIMUM_AMOUNT_MAX_RANGE,
  MINIMUM_AMOUNT_MIN_RANGE,
  ORDER_DISTANCE_RANGE,
  ORDER_DISTANCE_RANGE_MIN,
} from "../../store/constants";
import { cartAction } from "../../store/cartSlice";
import { toast } from "react-toastify";
import LandingStories from "./LandingStories";
import ReactInstaStories from "../InstaStoriesPackage/index.tsx";
import { storieAction } from "../../store/storieSlice.js";
import QuestionSwiperCard from "./QuestionSwiperCard.js";
import BotScreen from "./BotScreen.js";
import { fetchUserExperiences } from "../../store/chefActions.js";

const QUESTION_LIST = [
  {
    title:
      "Do you believe that a simple, plain Kulcha can still steal the show?",
  },
  {
    title: "Do you love the buttery bliss of a Kulcha brushed with ghee?",
  },
  {
    title: "Is a plate of spicy Chole the perfect partner for your Kulcha?",
  },
  {
    title:
      "Do stuffed Kulchas, like aloo or paneer, make your heart skip a beat?",
  },
];

const RecommendationModal = ({
  isModalOpen,
  handleCancel,
  setFoodChoiceState,
  foodChoiceState,
}) => {
  const swiperRef = useRef(null);
  const longPressTimer = useRef(null);
  const distanceMatrixRef = useRef(null);
  const coordsSelector = useSelector(({ auth }) => auth.coords);
  const user = useSelector(({ auth }) => auth.user);
  const chefList = useSelector((state) => state.chef.chefList);
  const swiperIndexRef = useRef();
  const startTimestampRef = useRef(null);
  const isAutoStoryEndRef = useRef();
  const addresses = user.addressLine1;
  const webviewLocationObjValue =
    JSON.parse(localStorage.getItem("webviewLocationObj")) || {};
  const [webviewLocationObj, setWebviewLocationObj] = useState(
    webviewLocationObjValue
  );
  let storySlideNumber = 0;
  const [showLocationModal, setShowLocationModal] = useState(false);
  const [my_swiper, set_my_swiper] = useState({});
  const [swiper, setSwiper] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isLocationCalled, setIsLocationCalled] = useState(false);
  const [step, setStep] = useState(1);
  console.log("step", step);
  const [userSelectionText, setUserSelectionText] = useState("");
  const [location, setLocation] = useState({
    loaded: false,
    coordinates: { lat: "", lng: "" },
  });
  const isBotScreen = step === 2;

  const isValidLocation =
    !!location?.coordinates?.lat &&
    !!location?.coordinates?.lng &&
    location.loaded;
  const isValidLocationSelector =
    !!coordsSelector?.lat && !!coordsSelector?.lng;
  const isLocationValid = isValidLocation || isValidLocationSelector;

  // const slideNext = () => {
  //   if (swiperRef.current.activeIndex > 3) {
  //     handleCancel();
  //     return;
  //   }
  //   if (swiperRef.current && swiperRef.current.slideNext) {
  //     swiperRef.current.slideNext();
  //   }
  // };

  const handleContextMenu = (e) => {
    e.preventDefault(); // prevent default right-click
    // slideNext();
  };

  const handleTouchStart = () => {
    // longPressTimer.current = setTimeout(slideNext, 500);
  };

  const clearLongPress = () => {
    clearTimeout(longPressTimer.current);
  };

  const [currentIndex, setCurrentIndex] = useState(QUESTION_LIST.length - 1);
  const [activeIndex, setActiveIndex] = useState(0);
  const [lastDirection, setLastDirection] = useState();
  const [isStartPageVisible, setIsStartPageVisible] = useState(true);
  const [questionList, setQuestionList] = useState([...QUESTION_LIST]);
  const currentIndexRef = useRef(currentIndex);
  const recommendationModalRef = useRef(null);
  const userid = useSelector(({ auth }) => auth.user.userid);

  const dispatch = useDispatch();

  let touchStartTime = null;
  let touchTimeout = null;

  const childRefs = useMemo(
    () =>
      Array(QUESTION_LIST.length)
        .fill(0)
        .map((i) => React.createRef()),
    []
  );

  const updateCurrentIndex = (val) => {
    setCurrentIndex(val);
    currentIndexRef.current = val;
  };

  const showError = (error) => {
    toast.error(error, {
      position: toast.POSITION.BOTTOM_CENTER,
      toastId: "info1",
    });
  };

  const onError = (error) => {
    if (Object.keys(webviewLocationObj).length !== 0) {
      try {
        // Parse the parameter into a JSON object
        onSuccess({
          coords: {
            longitude: webviewLocationObj?.lng,
            latitude: webviewLocationObj?.lat,
          },
        });
        console.log(webviewLocationObj);
      } catch (error) {
        setLocationError(error);
        console.error("Error parsing JSON:", error);
      } finally {
        setLoading(false);
        if (!isBotScreen) {
          setStep(3);
        }
      }
    } else {
      setLocationError(error);
      setLoading(false);
      if (!isBotScreen) {
        setStep(3);
      }
    }
    setLoading(false);
    if (!isBotScreen) {
      setStep(3);
    }
  };

  const setLocationError = (error) => {
    setLocation({
      loaded: false,
      error: {
        code: error.code,
        message: error.message,
      },
    });
  };

  const onSelectAddressHandler = (data, autoDetect) => {
    const uniqKitchenData = uniqBy(chefList, (obj) => obj.kitchenId);
    uniqKitchenData
      .filter((a) => a.kitchenId)
      .map((kitchen) => {
        const kitchenId = kitchen.kitchenId;
        const chefLocation = kitchen.chefLocation;
        distanceMatrixRef.current =
          new window.google.maps.DistanceMatrixService();
        const chefLocationObj = {
          lat: +chefLocation?.lat,
          lng: +chefLocation?.lng,
        };
        distanceMatrixRef.current.getDistanceMatrix(
          {
            origins: [chefLocationObj],
            destinations: [
              {
                lat: data?.location.lat,
                lng: data?.location.lng,
              },
            ],
            travelMode: "DRIVING",
          },
          (res, status) => {
            if (status !== "OK") {
              console.log("Unable to fetch...");
            } else {
              let delivery_distance = res.rows[0].elements[0].distance.value;
              let delivery_duration = res.rows[0].elements[0].duration;
              let delivery_destination = res.destinationAddresses[0];
              let deliveryObject = {
                delivery_distance,
                delivery_duration,
                kitchenLocation: chefLocation,
              };

              dispatch(
                loginActions.setDeliveryDetails({
                  kitchenId,
                  payload: deliveryObject,
                })
              );
              let deliverydeliveryDistanceInKMS = Math.round(
                delivery_distance / 1000
              );
              // const requestBody = {
              //   pickup_details: {
              //     building_name: "",
              //     latitude: chefLocation.lat,
              //     longitude: chefLocation.lng,
              //     address: res.originAddresses[0]
              //   },
              //   drop_details: {
              //     building_name: "",
              //     latitude: data?.location.lat,
              //     longitude: data?.location.lng,
              //     address: res.destinationAddresses[0]
              //   }
              // };

              const requestBody = {
                pickup_details: {
                  building_name: "NP Home Foods",
                  latitude: 12.933562657282067,
                  longitude: 77.61429533708163,
                  address:
                    "Apex Building 93/A Ground Floor, A Wing, 4th B Cross, 5th Block, Koramangala, Bengaluru, Karnataka 560095",
                },
                drop_details: {
                  building_name: "NP Sweet Home",
                  latitude: 12.93373883438634,
                  longitude: 77.61620254160374,
                  address:
                    "JNC, Hosur Rd, KHB Colony, 5th Block, Koramangala, Bengaluru, Karnataka 560095",
                },
              };

              // checkDeliveryServiceable(requestBody)
              if (deliverydeliveryDistanceInKMS > ORDER_DISTANCE_RANGE) {
                dispatch(loginActions.setIsServiceable(false));
                dispatch(loginActions.setIsServiceableAlert(true));
                dispatch(loginActions.setUnserviceableModalOnCart(true));
                dispatch(loginActions.setMinimumAmount(0));
              } else if (
                deliverydeliveryDistanceInKMS > ORDER_DISTANCE_RANGE_MIN &&
                deliverydeliveryDistanceInKMS <= ORDER_DISTANCE_RANGE
              ) {
                dispatch(loginActions.setIsServiceable(true));
                dispatch(loginActions.setIsServiceableAlert(false));
                dispatch(loginActions.setFarAwayModalOnCart(true));
                dispatch(
                  loginActions.setMinimumAmount(MINIMUM_AMOUNT_MAX_RANGE)
                );
              } else if (
                deliverydeliveryDistanceInKMS > FREE_DILIVERY_DISTANCE_RANGE &&
                deliverydeliveryDistanceInKMS < ORDER_DISTANCE_RANGE_MIN
              ) {
                dispatch(loginActions.setIsServiceable(true));
                dispatch(loginActions.setIsServiceableAlert(false));
                dispatch(
                  loginActions.setMinimumAmount(MINIMUM_AMOUNT_MIN_RANGE)
                );
              } else {
                dispatch(loginActions.setIsServiceable(true));
                dispatch(loginActions.setIsServiceableAlert(false));
                dispatch(loginActions.setMinimumAmount(0));
              }

              let coords = { lat: data.location.lat, lng: data.location.lng };
              dispatch(loginActions.setSelectedAddress(data));
              dispatch(loginActions.setLocation(data.location.locationName));
              dispatch(cartAction.setIsAddressOptionsVisible(false));
              dispatch(loginActions.setCoords(coords));
              dispatch(loginActions.setLocation(delivery_destination));

              const tempUser = {
                mpUserId: localStorage.getItem("mpUserId"),
                location: {
                  lat: data.location.lat,
                  lng: data.location.lng,
                  locationName: data.location?.area,
                },
              };
              dispatch(addTempUser(tempUser));
            }
          }
        );
      });
  };

  const getNearbyLocations = (currentLat, currentLng, locations) => {
    const threshold = 0.1; // Define your threshold distance in kilometers
    const nearbyLocations = [];

    function getDistance(lat1, lon1, lat2, lon2) {
      const R = 6371; // Radius of the Earth in kilometers
      const dLat = deg2rad(lat2 - lat1);
      const dLon = deg2rad(lon2 - lon1);
      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(deg2rad(lat1)) *
          Math.cos(deg2rad(lat2)) *
          Math.sin(dLon / 2) *
          Math.sin(dLon / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      const distance = R * c; // Distance in kilometers
      return distance;
    }

    function deg2rad(deg) {
      return deg * (Math.PI / 180);
    }

    locations.forEach((location) => {
      const distance = getDistance(
        currentLat,
        currentLng,
        location.location.lat,
        location.location.lng
      );
      if (distance <= threshold) {
        nearbyLocations.push(location);
      }
    });

    return nearbyLocations;
  };

  const onSuccess = (location) => {
    const nearbyLocations = getNearbyLocations(
      location.coords.latitude,
      location.coords.longitude,
      addresses
    );
    if (nearbyLocations?.length) {
      onSelectAddressHandler(nearbyLocations[0], false);
    } else {
      setLocation({
        loaded: true,
        coordinates: {
          lat: location.coords.latitude,
          lng: location.coords.longitude,
        },
      });
      onSelectAddressHandler(
        {
          location: {
            lat: location.coords.latitude,
            lng: location.coords.longitude,
          },
        },
        false
      );
      dispatch(
        loginActions.setCoords({
          lat: location.coords.latitude,
          lng: location.coords.longitude,
        })
      );

      const tempUser = {
        mpUserId: localStorage.getItem("mpUserId"),
        location: {
          lat: location.coords.latitude,
          lng: location.coords.longitude,
          locationName: location.coords?.area,
        },
      };
      dispatch(addTempUser(tempUser));
    }
    setLoading(false);
    if (!isBotScreen) {
      setStep(3);
    }
  };

  const onGeoLocationClickHandler = (isBotScreen = false) => {
    if (isLocationCalled) return;
    mixpanel.track("geolocation-clicked");
    // clevertap.event.push("geolocation-clicked");
    setLoading(true);
    setIsLocationCalled(true);
    if (
      Object.keys(webviewLocationObj).length === 0 &&
      window.ReactNativeWebView
    ) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({ type: "ASK_LOCATION_PERMISSION" })
      );
      setLoading(false);
      if (!isBotScreen) {
        setStep(3);
      }
    } else if (
      Object.keys(webviewLocationObj).length !== 0 &&
      window.ReactNativeWebView
    ) {
      try {
        onSuccess({
          coords: {
            longitude: webviewLocationObj?.lng,
            latitude: webviewLocationObj?.lat,
          },
        });
      } catch (error) {
        setLocationError(error);
        console.error("Error parsing JSON:", error);
      } finally {
        setLoading(false);
        if (!isBotScreen) {
          setStep(3);
        }
      }
    } else if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(onSuccess, onError, {
        enableHighAccuracy: true,
      });
    } else {
      setLoading(false);
      if (!isBotScreen) {
        setStep(3);
      }
      showError("Geolocation not supported");
    }
  };

  // useEffect(() => {
  //   const handleTap = (e) => {
  //     const bounds = recommendationModalRef.current.getBoundingClientRect();
  //     const tapX = e.clientX || (e.touches && e.touches[0].clientX); // support touch + click
  //     const isRightSide = tapX > bounds.left + bounds.width / 2;

  //     if (isRightSide) {
  //       slideNext();
  //     }
  //   };

  //   const currentRef = recommendationModalRef.current;
  //   if (currentRef) {
  //     currentRef.addEventListener("click", handleTap);
  //     // currentRef.addEventListener("touchstart", handleTap);
  //   }

  //   return () => {
  //     if (currentRef) {
  //       currentRef.removeEventListener("click", handleTap);
  //       // currentRef.removeEventListener("touchstart", handleTap);
  //     }
  //   };
  // }, []);

  // const swiped = (direction, nameToDelete, index) => {
  //   setLastDirection(direction);
  //   updateCurrentIndex(index - 1);
  //   const currentIndex = questionList.findIndex(
  //     (q) => q.title === nameToDelete
  //   );
  //   const isInterested = direction === "right";
  //   const dummyQuestionList = [...questionList];
  //   dummyQuestionList[currentIndex].isInterested = isInterested;
  //   setQuestionList(dummyQuestionList);
  //   if (index === 0) {
  //     handleCancel();
  //     if (userid) {
  //       const payload = { foodChoice: dummyQuestionList };
  //       dispatch(updateFoodChoiceInfo(userid, payload));
  //     }
  //   }
  // };

  const canSwipe = currentIndex >= 0;

  const swipe = async (dir) => {
    if (canSwipe && currentIndex < QUESTION_LIST.length) {
      await childRefs[currentIndex].current.swipe(dir); // Swipe the card!
    }
  };

  const getResponsiveFontSize = () => {
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;

    const minWidth = 354;
    const maxWidth = 425;
    const minFont = 25;
    const maxFont = 32;

    // Width-based logic (unchanged)
    let widthBasedFont;
    if (screenWidth <= minWidth) widthBasedFont = minFont;
    else if (screenWidth >= maxWidth) widthBasedFont = maxFont;
    else {
      const widthRatio = (screenWidth - minWidth) / (maxWidth - minWidth);
      widthBasedFont = minFont + widthRatio * (maxFont - minFont);
    }

    // Height override logic
    const minHeight = 659;
    const maxHeight = 809;
    const minHeightFont = 20;

    if (screenHeight <= minHeight) {
      return minHeightFont;
    } else if (screenHeight >= maxHeight) {
      return widthBasedFont;
    } else {
      // Interpolate between 20 (at 659) and widthBasedFont (at 809)
      const heightRatio = (screenHeight - minHeight) / (maxHeight - minHeight);
      return minHeightFont + heightRatio * (widthBasedFont - minHeightFont);
    }
  };

  const fontSize = getResponsiveFontSize();

  const getResponsiveSize = () => {
    const screenHeight = window.innerHeight;

    const minHeight = 659;
    const maxHeight = 809;
    const minGap = 65;
    const maxGap = 72;

    if (screenHeight <= minHeight) return minGap;
    if (screenHeight >= maxHeight) return maxGap;

    const ratio = (screenHeight - minHeight) / (maxHeight - minHeight);
    return minGap + ratio * (maxGap - minGap);
  };

  const size = getResponsiveSize();

  const getResponsiveBottom = () => {
    const screenHeight = window.innerHeight;

    const minHeight = 659;
    const maxHeight = 809;
    const minBottom = 15;
    const maxBottom = 30;

    if (screenHeight <= minHeight) return minBottom;
    if (screenHeight >= maxHeight) return maxBottom;

    const ratio = (screenHeight - minHeight) / (maxHeight - minHeight);
    return minBottom + ratio * (maxBottom - minBottom);
  };

  const bottom = getResponsiveBottom();

  const getResponsiveCardSize = () => {
    const screenHeight = window.innerHeight;

    const minHeight = 659;
    const maxHeight = 809;

    const minCardWidth = 240;
    const maxCardWidth = 280;

    const minCardHeight = 400;
    const maxCardHeight = 460;

    if (screenHeight <= minHeight) {
      return { cardWidth: minCardWidth, cardHeight: minCardHeight };
    }

    if (screenHeight >= maxHeight) {
      return { cardWidth: maxCardWidth, cardHeight: maxCardHeight };
    }

    const ratio = (screenHeight - minHeight) / (maxHeight - minHeight);

    const cardWidth = minCardWidth + ratio * (maxCardWidth - minCardWidth);
    const cardHeight = minCardHeight + ratio * (maxCardHeight - minCardHeight);

    return { cardWidth, cardHeight };
  };

  const handleSwipeNextClick = (tags) => {
    // setStep(4);
    setStep(5);
    dispatch(
      fetchUserExperiences(tags, (err, res) => {
        console.log("err, res", err, res);
        handleCancel();
      })
    );
  };

  const swipeToNextSlide = () => {
    if (swiper) {
      const curInd = swiper.activeIndex;
      if (curInd === sortedDailyFirstExploredDishes?.length - 1) {
        return false;
      } else {
        return true;
      }
    }
  };

  const handleSubmitAnswer = (answer) => {
    setUserSelectionText(answer.question);
    // dispatch(
    //   getDishRecommendation(answer, (err, res) => {
    //     console.log("err, res", err, res);
    //     // handleCancel();
    //   })
    // );
  };

  const handleNextSlide = () => {
      if (my_swiper && my_swiper.slideNext) {
        my_swiper.slideNext();
      }
  }

  const getDishRecommendationApi = (payload) => {
    dispatch(
      getDishRecommendation(payload, (err, res) => {
        console.log("err, res", err, res);
        handleCancel();
      })
    );
  };

  const { cardWidth, cardHeight } = getResponsiveCardSize();

  // Keep slide data and story content components referentially stable. A new
  // `content` function on every render makes the stories package remount the
  // slide, which resets the image-loaded state (spinner) and re-creates the
  // <img> (black flash).
  const sortedDailyFirstExploredDishes = useMemo(() => [
    {
      type: "story",
      items: [
        {
          content: LandingStory01,
          src: LandingStory01Img,
        }
      ],
    },
    {
      type: "story",
      items: [
        {
          content: LandingStory02,
          src: LandingStory02Img,
        }
      ],
    },
    {
      type: "story",
      items: [
        {
          content: LandingStory03,
          src: LandingStory03Img,
        }
      ],
    },
    {
      type: "story",
      items: [
        {
          content: LandingStory04,
          src: LandingStory04Img,
        },
      ],
    },
    // {
    //   type: "story",
    //   items: [
    //     {
    //       content: LandingStory11,
    //       src: ExploreStoryLanding1,
    //     },
    //     {
    //       content: LandingStory12,
    //       src: ExploreStoryLanding2,
    //     },
    //     {
    //       content: LandingStory13,
    //       src: ExploreStoryLanding3,
    //     },
    //     {
    //       content: LandingStory14,
    //       src: ExploreStoryLanding4,
    //     },
    //   ],
    // },
    // {
    //   type: "story",
    //   items: [
    //     {
    //       content: LandingStory21,
    //       src: ExploreChef23,
    //     },
    //     {
    //       content: LandingStory22,
    //       src: ExploreChef24,
    //     },
    //     {
    //       content: LandingStory23,
    //       src: ExploreChef25,
    //     },
    //     // {
    //     //   content: LandingStory24,
    //     //   src: ExploreChef27,
    //     // },
    //     {
    //       content: LandingStory25,
    //       src: ExploreChef26,
    //     },
    //   ],
    // },
    // TODO: restore landing design
  ], []);

  const handlersRef = useRef({});
  handlersRef.current = {
    onGeoLocationClickHandler,
    handleCancel: () => {
      setStep(2);
      // TODO: restore landing design
      handleCancel();
    },
    handleNextSlide,
  };

  const landingStoriesList = useMemo(
    () =>
      sortedDailyFirstExploredDishes.map((dish, index) =>
        dish.items.map((label, i) => ({
          content: ({ action, isPaused }) => (
            <LandingStories
              label={label}
              action={action}
              isPaused={isPaused}
              swiperIndexRef={swiperIndexRef}
              exploreIndex={index}
              storyIndex={i}
              onGeoLocationClickHandler={(...args) =>
                handlersRef.current.onGeoLocationClickHandler(...args)
              }
              handleCancel={() => handlersRef.current.handleCancel()}
              handleNextSlide={() => handlersRef.current.handleNextSlide()}
            />
          ),
          preloadResource: true,
          duration: 0,
        }))
      ),
    [sortedDailyFirstExploredDishes]
  );

  useEffect(() => {
    sortedDailyFirstExploredDishes.forEach((dish) =>
      dish.items.forEach((item) => {
        const img = new Image();
        img.src = item.src;
      })
    );
  }, [sortedDailyFirstExploredDishes]);

  return (
    <div>
      <div
        className="swiper-wrapper-container"
        // onContextMenu={handleContextMenu}
        // onTouchStart={handleTouchStart}
        // onTouchEnd={clearLongPress}
        // onTouchCancel={clearLongPress}
        ref={recommendationModalRef}
        style={{ zIndex: 1000 }}
      >
        {step === 1 && (
          <Swiper
            direction={"vertical"}
            modules={[EffectFade]}
            pagination={{
              clickable: true,
            }}
            // height={screenHeight}
            onInit={(ev) => {
              dispatch(storieAction.setLandingSwiperIndex(ev.activeIndex));
              swiperIndexRef.current = ev.activeIndex;
              set_my_swiper(ev);
            }}
            onSlideChange={(s) => {
              // checkMuteVideo();
              if (s.isEnd) {
                setStep(3);
                // setStep(4);
                // TODO: restore landing design
                // handleCancel()
              }
              dispatch(storieAction.setLandingSwiperIndex(s.activeIndex));
              swiperIndexRef.current = s.activeIndex;
              // dispatch(storieAction.setRunJoyride(false));
              setSwiper(s);
              mixpanel.track(`explore dish change`);
              // clevertap.event.push(`explore dish change`);
              if (s.activeIndex === 1) {
                if (!isLocationValid) {
                  // setShowLocationModal(true);
                }
                console.log("slide change");
              }
            }}
            style={{ height: `${window.innerHeight}px`, background: "#000" }}

            onSwiper={(s) => setSwiper(s)}
            className="explore-swiper-wrapper"
          >
            {sortedDailyFirstExploredDishes.map((dish, index) => {
              if (dish.type === "story") {
                const storiesArrayData = landingStoriesList[index];

                return (
                  <SwiperSlide key={index}>
                    {({ isActive }) => (
                      <ReactInstaStories
                        key={index}
                        isPaused={index !== swiperIndexRef.current}
                        stories={storiesArrayData}
                        showProgress={false}
                        defaultInterval={0}
                        width="100%"
                        preloadCount={2}
                        height="100%"
                        progressContainerStyles={{ top: "2px" }}
                        instaIndex={index}
                        onStoryStart={(s) => {
                          if (index === swiperIndexRef.current) {
                            startTimestampRef.current = performance.now();
                            storySlideNumber = s;
                          }
                        }}
                        onStoryEnd={(s) => {
                          mixpanel.track(`explore story end`);
                          // clevertap.event.push(`explore story end`);
                          isAutoStoryEndRef.current = true;
                          if (index === swiperIndexRef.current) {
                            storySlideNumber = s;
                          }
                          if (startTimestampRef.current !== null) {
                            const endTimestamp = performance.now();
                            const timeDifference =
                              endTimestamp - startTimestampRef.current;
                            if (timeDifference > 5300) {
                              const pausedDishesIds =
                                user.pausedDishesIds || [];
                              const allDishesPausedIds = [
                                ...new Set([...pausedDishesIds, dish._id]),
                              ];
                              const payload = {
                                pausedDishesIds: allDishesPausedIds,
                              };
                              // dispatch(updatePausedDishesInfo(user.userid, payload));
                            }
                            startTimestampRef.current = performance.now();
                          }
                          // if (s === dish.stories.length + 1 - 1) { TODO:
                          // if (s === dish.items.length - 1) {
                          //   const canSwipe = swipeToNextSlide();
                          //   if (canSwipe) {
                          //     storySlideNumber = 0;
                          //     my_swiper.slideNext();
                          //   } else {
                          //     setStep(2);
                          //     // TODO: restore landing design
                          //     handleCancel()
                          //   }
                          // }
                        }}
                      />
                    )}
                  </SwiperSlide>
                );
              }
            })}

            <SwiperSlide key={909090}>
              {({ isActive }) => <div></div>}
            </SwiperSlide>
          </Swiper>
        )}

        {step === 2 && (
          <div style={{ height: "100dvh" }} className="image-container_wrapper">
            <div
              style={{
                position: "absolute",
                top: "0px",
                height: "100dvh",
                backgroundColor: "#fff",
              }}
              className="image-container"
            >
              <BotScreen
                onGeoLocationClickHandler={onGeoLocationClickHandler}
                setStepScreen={setStep}
              />
            </div>
          </div>
        )}

        {step === 3 && (
          <div style={{ height: "100dvh" }} className="image-container_wrapper">
            <div
              style={{
                position: "absolute",
                top: "0px",
                height: "100dvh",
                backgroundColor: "#fff",
              }}
              className="image-container"
            >
              <SurveyAnswer
                isActive={true}
                handleSwipeNextClick={handleSwipeNextClick}
                handleSubmitAnswer={handleSubmitAnswer}
                setFoodChoiceState={setFoodChoiceState}
                onGeoLocationClickHandler={onGeoLocationClickHandler}
                handleCancel={handleCancel}
              />
            </div>
          </div>
        )}

        {step === 4 && (
          <div style={{ height: "100dvh" }} className="image-container_wrapper">
            <div
              style={{
                position: "absolute",
                top: "0px",
                height: "100dvh",
                backgroundColor: "#fff",
              }}
              className="image-container"
            >
              <QuestionSwiperCard
                handleCancel={() => setStep(5)}
                foodChoiceState={foodChoiceState}
                userSelectionText={userSelectionText}
                getDishRecommendationApi={getDishRecommendationApi}

              />
            </div>
          </div>
        )}

        {step === 5 && (
          <div
            style={{ position: "absolute", top: "0px", height: "100%" }}
            className="image-container"
          >
            <ExploreSkeleton
              isActive={true}
              darkMode
              handleCancel={handleCancel}
            />
          </div>
        )}

        {/* <Swiper
          direction="vertical"
          modules={[EffectFade]}
          pagination={{ clickable: true }}
          onSlideChange={(s) => {
            setActiveIndex(s.activeIndex);
            if (s.activeIndex + 2 > slidesData.length) {
              setTimeout(() => {
                handleCancel();
              }, 1500);
            }
          }}
          ref={swiperRef}
          onSwiper={(swiper) => {
            swiperRef.current = swiper;
          }}
          className="swiper-box"
          onBeforeSlideChangeStart={(swiper) => {
            if (swiper.activeIndex === 0) {
              // Optional actions when on first slide
            }
          }}
        >
          {slidesData.map(({ key, render }) => (
            <SwiperSlide key={key} className="swiper-slide-custom">
              {({ isActive }) => render(isActive)}
            </SwiperSlide>
          ))}
        </Swiper> */}
      </div>
      <LocationChoiceModal
        isOpen={showLocationModal}
        setOpen={setShowLocationModal}
        loading={loading}
        isLocationValid={isLocationValid}
        manualLocationClick={() => {}}
        onGeoLocationClickHandler={onGeoLocationClickHandler}
        showManualLocation={false}
        swiperRef={swiperRef}
      />
    </div>
  );
};

export default RecommendationModal;
